import React, { useState, useEffect, useContext, useMemo } from "react";
import { AuthContext } from "../../../contexts/AuthContext";
import {
  Col,
  Row,
  Form,
  Button,
  FormGroup,
  Label,
  Input,
  Spinner,
  Modal,
  ModalHeader,
  ModalBody,
  Table,
} from "reactstrap";
import axios from "axios";
import SweetAlert from "sweetalert2-react";
import Swal from "sweetalert2";
import Header from "../../../layout/Header/Header";
import TextField from "@material-ui/core/TextField";
import Autocomplete from "@material-ui/lab/Autocomplete";
import moment from "moment";
import { v4 as uuidv4 } from "uuid";
import CurrencyInput from "react-currency-input-field";
import { formatValue } from "react-currency-input-field";
import { makeStyles } from "@material-ui/core/styles";
import { jsPDF } from "jspdf";
import "jspdf-autotable";
import autoTable from "jspdf-autotable";
import ExportJsonExcel from "js-export-excel";
import { encode } from "base64-arraybuffer";
import * as XLSX from "xlsx";

const useStyles = makeStyles((theme) => ({
  root: {
    "& .MuiTextField-root": {
      margin: theme.spacing(1),
    },
  },
  button: {
    margin: theme.spacing(1),
  },
}));

function VentaDirectaCreate() {
  const { user } = useContext(AuthContext);
  const URL_LOGS = process.env.REACT_APP_URL_LOGS;
  const URL_INVENTARIOS = process.env.REACT_APP_URL_INVENTARIOS;
  const URL_ARTICULOS = process.env.REACT_APP_URL_ARTICULOS;
  const URL_COLABORADORES = process.env.REACT_APP_URL_COLABORADORES;
  const URL_CLIENTES = process.env.REACT_APP_URL_CLIENTES;
  const URL_PEDIDOS = process.env.REACT_APP_URL_PEDIDOS;
  const URL_SURTIDOS = process.env.REACT_APP_URL_SURTIDOS;
  const URL_ARTICULOS_PEDIDO = process.env.REACT_APP_URL_ARTICULOS_PEDIDO;
  const URL_ARTICULOS_SURTIDOS = process.env.REACT_APP_URL_ARTICULOS_SURTIDOS;
  const URL_AREAS = process.env.REACT_APP_URL_AREAS;
  const AREAS_CEDIS = process.env.REACT_APP_AREAS_CEDIS;
  // const AREAS_MIXCALCO = process.env.REACT_APP_AREAS_MIXCALCO;
  const PASSWORD_CAMBIA_PRECIO = process.env.REACT_APP_PASSWORD_CAMBIA_PRECIO;
  // const URL_PAQUETERIAS = process.env.REACT_APP_URL_PAQUETERIAS;
  const URL_SEND_MAIL = process.env.REACT_APP_URL_SEND_MAIL;
  const URL_BANCOS = process.env.REACT_APP_URL_BANCOS;
  const URL_ABONOS = process.env.REACT_APP_URL_ABONOS;
  // const URL_WHATSAPP = process.env.REACT_APP_URL_WHATSAPP;
  const URL_SUCURSALES = process.env.REACT_APP_URL_SUCURSALES;
  const URL_VARIANTES = process.env.REACT_APP_URL_VARIANTES_ARTICULOS;
  const AREAS_MELI = process.env.REACT_APP_AREAS_MELI_1_FULL;
  const AREAS_MELI_NOVA = process.env.REACT_APP_AREAS_MELI_2_FULL;
  const AREAS_AMAZON = process.env.REACT_APP_AREAS_AMAZON_1_FBA;
  const AREAS_AMAZON_YOU = process.env.REACT_APP_AREAS_AMAZON_2_FBA;

  let date = new Date();
  let hoy = moment(date).format("YYYY-MM-DD");

  const [articulos, setArticulos] = useState([]);
  // const [idsArticulos, setIdsArticulos] = useState([]);
  const [clientes, setClientes] = useState([]);
  const [selectedCliente, setSelectedCliente] = useState("");
  const [sucursales, setSucursales] = useState([]);
  const [selectedSucursal, setSelectedSucursal] = useState([]);
  const [sucursal, setSucursal] = useState("");
  const [colaboradores, setColaboradores] = useState([]);
  const [selectedColaborador, setSelectedColaborador] = useState("");
  const [selectedColaboradorName, setSelectedColaboradorName] = useState("");
  const [value, setValue] = useState("");
  const [articulosUnicos, setArticulosUnicos] = useState([]);
  const [articulosCatalogo, setArticulosCatalogo] = useState([]);
  const [totalCaptura, setTotalCaptura] = useState(1);

  const [modalProgreso, setModalProgreso] = useState(false);
  const toggleProgreso = () => setModalProgreso(!modalProgreso);

  const [inventarios, setInventarios] = useState([]);

  const [cliente, setCliente] = useState("");
  const [condPago, setCondPago] = useState("Contado");
  const [departamentoCliente, setDepartamentoCliente] = useState("");
  const [paqueterias, setPaqueterias] = useState([]);
  const [paqueteria, setPaqueteria] = useState("NA");
  const [idPaqueteria, setIdPaqueteria] = useState("650b273bc9855e3f883e8f5d");
  const [areas, setAreas] = useState([]);
  const [selectedArea, setSelectedArea] = useState(AREAS_CEDIS);
  const [selectedAreaName, setSelectedAreaName] = useState("CEDIS");
  const [comisionTDC, setComisionTDC] = useState(0);
  const [comisionFlete, setComisionFlete] = useState(0);
  const [descuento, setDescuento] = useState(0);
  const [descuentoNumero, setDescuentoNumero] = useState(0);

  const [fecha, setFecha] = useState(hoy);
  const [observaciones, setObservaciones] = useState("NA");
  const [total_general, setTotalGeneral] = useState(0);
  const [subTotal, setSubTotal] = useState(0);
  const [iva, setIva] = useState(0);
  const [total_cantidad, setTotalCantidad] = useState(0);
  const [total_cajas, setTotalCajas] = useState(0);
  const [selectedImpuesto, setSelectedImpuesto] = useState(0);

  // const [descuento, setDescuento] = useState(0);
  // const [descuentoNumero, setDescuentoNumero] = useState(0);

  const [listaPrecios, setListaPrecios] = useState(1);

  const [bancos, setBancos] = useState([]);
  const [codigoAgrupado, setCodigoAgrupado] = useState(uuidv4());

  const [pago, setPago] = useState();
  const [efectivo, setEfectivo] = useState(0);
  const [tdc, setTDC] = useState(0);
  const [transfer, setTransfer] = useState(0);
  const [fechaTransfer, setFechaTransfer] = useState("NA");
  const [referencia, setReferencia] = useState("NA");
  const [destino, setDestino] = useState("NA");
  const [terminal, setTerminal] = useState("Tarjeta");
  const [saldo, setSaldo] = useState(0);

  const classes = useStyles();
  const [inputFields, setInputFields] = useState([
    {
      id: uuidv4(),
      articulos: "",
      piezasPorCaja: 0,
      cajas: 0,
      cantidad: 0,
      precio: 0,
      precioBruto: 0,
      precioOriginal: 0,
      total: 0,
      articulosNombre: "",
      observacionesArticulo: "NA",
      idInv: "",
      costoUnitario: 0,
      cantInv: 0,
      variante: "",
      variantesOptions: [],
    },
  ]);

  const [validaBoton, setValidaBoton] = useState(true);
  const [cambiarPrecio, setCambiarPrecio] = useState(false);

  const [modalCambiaPrecio, setModalCambiaPrecio] = useState(false);
  const toggleCambiaPrecio = () => setModalCambiaPrecio(!modalCambiaPrecio);
  const [password, setPassword] = useState("");

  const [mailAutEnviado, setMailAutEnviado] = useState(false);
  const [randomCambiaPrecio, setRandomCambiaPrecio] = useState(
    (Math.random() + 1).toString(36).substring(2)
  );

  useMemo(() => {
    axios
      .get(`${URL_ARTICULOS}`, {
        headers: {
          Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
        },
      })
      .then((res) => {
        const allArticulosCat = res.data;
        setArticulosCatalogo(allArticulosCat);
      })
      .catch((err) => {
        console.log(err);
      });

    axios
      .get(`${URL_CLIENTES}`, {
        headers: {
          Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
        },
      })
      .then((res) => {
        const allClientes = res.data;
        setClientes(allClientes);
      })
      .catch((err) => {
        console.log(err);
      });
    axios
      .get(URL_COLABORADORES, {
        headers: {
          Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
        },
      })
      .then((res) => {
        const allColaboradores = res.data;
        setColaboradores(allColaboradores);
      })
      .catch((err) => {
        console.log(err);
      });
    // axios
    //   .get(URL_PAQUETERIAS, {
    //     headers: {
    //       Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
    //     },
    //   })
    //   .then((res) => {
    //     const allPaqueterias = res.data;
    //     setPaqueterias(allPaqueterias);
    //   })
    //   .catch((err) => {
    //     console.log(err);
    //   });

    axios
      .get(URL_AREAS, {
        headers: {
          Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
        },
      })
      .then((res) => {
        const allAreas = res.data;
        setAreas(allAreas);
      })
      .catch((err) => {
        console.log(err);
      });

    if (selectedArea) {
      axios
        .get(`${URL_INVENTARIOS}AcumuladoAlmacen/${selectedArea}`, {
          headers: {
            Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
          },
        })
        .then((response) => {
          let allDisponible = response.data;
          setInventarios(allDisponible);

          setArticulos(allDisponible);
          // let result = allDisponible.map((a) => a.idArticulo);
          // setIdsArticulos(result);

          let unicos = allDisponible.filter(
            (value, index, self) =>
              index === self.findIndex((t) => t.idArticulo === value.idArticulo)
          );
          setArticulosUnicos(unicos);
        })
        .catch((err) => {
          console.log(err);
        });
    }
    axios
      .get(URL_BANCOS, {
        headers: {
          Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
        },
      })
      .then((response) => {
        let allBancos = response.data;
        setBancos(allBancos);
      })
      .catch((err) => {
        console.log(err);
      });

    // if(selectedCliente == "650a334ab99f0b3555a8cf16"){
    //   axios
    //   .get(`${URL_CLIENTES}/${selectedCliente}`, {
    //     headers: {
    //       Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
    //     },
    //   })
    //   .then((res) => {
    //     const allCliente = res.data;
    //     setCliente(allCliente);
    //     // setDescuento(allCliente.descuento);
    //     setListaPrecios(allCliente.listaPrecios);
    //     setSelectedColaborador(allCliente.vendedor[0]._id);
    //     setSelectedColaboradorName(allCliente.vendedor[0].nombre + " " + allCliente.vendedor[0].apellido);
    //     setDepartamentoCliente(allCliente.departamentosClientes[0]._id);
    //     setCondPago(allCliente.forma_pago);
    //     if(allCliente.forma_pago == "Credito"){
    //       setPago(false)
    //     }else setPago(true)
    //       })
    //       .catch((err) => {
    //         console.log(err);
    //       });
    // }
  }, [selectedArea]);

  const savePedido = async (event) => {
    event.preventDefault();
    let cantidadIF = inputFields.length;
    let contador = 0;
    inputFields.map(async (a) => {
      if (a.cantInv >= a.cantidad) {
        return (contador = contador + 1);
      }
    });
  // Validar precios > 0
  const preciosInvalidos = inputFields.filter(
    (a) => parseFloat(a.precio) <= 0
  );

  if (preciosInvalidos.length > 0) {
    Swal.fire({
      icon: "error",
      title: "Oops...",
      text: "Hay artículos con precio menor o igual a 0. Verifica antes de guardar.",
    });
    return;
  }
    if (contador == cantidadIF) {
      if (selectedCliente != "" && selectedArea != "") {
        setValidaBoton(false);
        toggleProgreso();
        let totalPedido = inputFields.length;
        try {
          await axios
            .post(
              URL_PEDIDOS,
              {
                fecha,
                clientes: selectedCliente,
                departamentosClientes: departamentoCliente,
                colaboradores: selectedColaborador,
                total_general: parseFloat(total_general).toFixed(2),
                observaciones,
                total_cantidad,
                paqueterias: "665e148c225a1c1e3f506999",
                areas: selectedArea,
                sucursales: sucursal,
                comisionTDC,
                comisionFlete,
                subTotal: parseFloat(subTotal).toFixed(2),
                iva: parseFloat(iva).toFixed(2),
                impuestos: selectedImpuesto,
                surtido: "Si",
                autorizadoApartado: "Si",
                autorizadoSurtido: "Si",
                editado: "No",
                fechaModificado: fecha,
                creado: user.id,
                fecha_estimada: fecha,
                fecha_entrega: fecha,
                entregaInsumos: "No",
              },
              {
                headers: {
                  Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
                },
              }
            )
            .then(async (dataPedido) => {
              await axios
                .post(
                  URL_SURTIDOS,
                  {
                    fecha,
                    pedidos: dataPedido.data._id,
                    observaciones,
                    user: user.id,
                    clientes: selectedCliente,
                    areas: selectedArea,
                    total_general: parseFloat(total_general).toFixed(2),
                    saldo: parseFloat(saldo).toFixed(2),
                    subTotal: parseFloat(subTotal).toFixed(2),
                    iva: parseFloat(iva).toFixed(2),
                    impuestos: selectedImpuesto,
                    is_active: "Si",
                    entregado: "Si",
                    paqueterias: "665e148c225a1c1e3f506999",
                    colaboradores: selectedColaborador,
                    comisionPagada: "No",
                  },
                  {
                    headers: {
                      Authorization: `Bearer: ${localStorage.getItem(
                        "app_token"
                      )}`,
                    },
                  }
                )
                .then((dataSurtido) => {
                  // PDFOCSurtido(
                  //   dataSurtido.data.idSurtido,
                  //   dataSurtido.data.updatedAt,
                  //   dataPedido.data.idPedido
                  // );

                  inputFields.map((a) => {
                    if (a.articulos != "" && a.cantidad != 0) {
                      axios
                        .post(
                          URL_ARTICULOS_PEDIDO,
                          {
                            pedidos: dataPedido.data._id,
                            articulos: a.articulos,
                            cantidad: parseFloat(a.cantidad),
                            cantidadProcesos: 0,
                            pendiente_surtir: parseFloat(a.cantidad),
                            surtido: 0,
                            precio: parseFloat(a.precio).toFixed(2),
                            precioBruto: parseFloat(a.precioBruto).toFixed(2),
                            total: parseFloat(a.total).toFixed(2),
                            cliente: "NA",
                            variante: a.variante || null,
                          },
                          {
                            headers: {
                              Authorization: `Bearer: ${localStorage.getItem(
                                "app_token"
                              )}`,
                            },
                          }
                        )
                        .then((dataArtPed) => {
                          axios
                            .post(
                              `${URL_ARTICULOS_SURTIDOS}/ventaDirecta`,
                              {
                                fecha,
                                surtidos: dataSurtido.data._id,
                                inventarios: a.idInv,
                                cantidad: parseFloat(a.cantidad),
                                articulos: a.articulos,
                                pedidos: dataPedido.data._id,
                                articulosPedido: dataArtPed.data._id,
                                costoUnitario: a.costoUnitario,
                                clientes: selectedCliente,
                                areas: selectedArea,
                                precio: parseFloat(a.precio).toFixed(2),
                                precioBruto: parseFloat(a.precioBruto).toFixed(2),
                                paqueterias: "665e148c225a1c1e3f506999",
                                porEntregar: a.cantidad,
                                entregadoCantidad: 0,
                                entregado: "No",
                                variante: a.variante || null,
                              },
                              {
                                headers: {
                                  Authorization: `Bearer: ${localStorage.getItem(
                                    "app_token"
                                  )}`,
                                },
                              }
                            )

                            .then((data) => {
                              totalPedido = totalPedido - 1;
                              if (totalPedido == 0) {
                                axios
                                  .post(
                                    URL_LOGS,
                                    {
                                      tipo: "Crear Pedido",
                                      detalle: `${value._id} ${total_general}`,
                                      user: user.id,
                                    },
                                    {
                                      headers: {
                                        Authorization: `Bearer: ${localStorage.getItem(
                                          "app_token"
                                        )}`,
                                      },
                                    }
                                  )
                                  .then(() => {
                                    Swal.fire(
                                      "Good job!",
                                      "Creado con exito",
                                      `success`
                                    );
                                    setTimeout(() => {
                                      window.location.reload();
                                    }, 1000);
                                  });
                              }
                            })
                            .catch((error) => {
                              Swal.fire({
                                icon: "error",
                                title: "Oops...",
                                text: "Something went wrong!",
                                // footer: `${error.response.data}`,
                              });
                              console.log(error);
                              setValidaBoton(true);
                            });
                        });
                    } else {
                      totalPedido = totalPedido - 1;
                      if (totalPedido == 0) {
                        axios
                          .post(
                            URL_LOGS,
                            {
                              tipo: "Crear Pedido",
                              detalle: `${value._id} ${total_general}`,
                              user: user.id,
                            },
                            {
                              headers: {
                                Authorization: `Bearer: ${localStorage.getItem(
                                  "app_token"
                                )}`,
                              },
                            }
                          )
                          .then(() => {
                            Swal.fire(
                              "Good job!",
                              "Creado con exito",
                              `success`
                            );
                            setTimeout(() => {
                              window.location.reload();
                            }, 1000);
                          });
                      }
                    }
                  });
                })
                .catch((error) => {
                  Swal.fire({
                    icon: "error",
                    title: "Oops...",
                    text: "Something went wrong!",
                    // footer: `${error.response.data}`,
                  });
                  console.log(error);
                  setValidaBoton(true);
                });
            })
            .catch((error) => {
              Swal.fire({
                icon: "error",
                title: "Oops...",
                text: "Something went wrong!",
                footer: `${error.response.data}`,
              });
              console.log(error);
              setValidaBoton(true);
            });
        } catch (error) {
          Swal.fire({
            icon: "error",
            title: "Oops...",
            text: "Something went wrong!",
            footer: `${error.response.data}`,
          });
          console.log(error);
        }
      } else {
        Swal.fire({
          icon: "error",
          title: "Oops...",
          text: "Faltan datos, favor de revisar",
        });
      }
    } else {
      Swal.fire({
        icon: "error",
        title: "Oops...",
        text: "No puedes vender sin inventario",
        showConfirmButton: false,
      });
    }
  };

  const handleAddFields = () => {
    const ultimo = inputFields[inputFields.length - 1];
    setInputFields([
      ...inputFields,
      {
        id: uuidv4(),
        articulos: "",
        piezasPorCaja: 0,
        cajas: 0,
        cantidad: 0,
        precio: 0,
        precioBruto: 0,
        precioOriginal: 0,
        total: 0,
        articulosNombre: "",
        observacionesArticulo: "NA",
        idInv: "",
        costoUnitario: 0,
        cantInv: 0,
        variante: "",
        variantesOptions: [],
      },
    ]);
  };

  const handleRemoveFields = (id) => {
    const values = [...inputFields];
    values.splice(
      values.findIndex((value) => value.id === id),
      1
    );
    setInputFields(values);
    let totalCan = values.map((c) => parseFloat(c.cantidad));
    let TC = totalCan.reduce((t, total, index) => t + total, 0);
    setTotalCantidad(TC);
    let totalCajas = values.map((c) => parseFloat(c.cajas));
    let TCajas = totalCajas.reduce((t, total, index) => t + total, 0);
    setTotalCajas(TCajas);
    let importes = values.map((c) => parseFloat(c.total));
    let TG = importes.reduce((t, total, index) => t + total, 0);
    setSubTotal(TG);

    if (selectedImpuesto != 0) {
      setIva((selectedImpuesto * TG) / 100);
    } else {
      setIva(0);
    }
    let temp1 = (TG * descuento) / 100;

    setDescuentoNumero(temp1);

    let totTemp =
      (selectedImpuesto * TG) / 100 +
      TG +
      parseFloat(comisionTDC) +
      parseFloat(comisionFlete) -
      parseFloat(temp1);

    setTotalGeneral(totTemp);
  };

  const handleChangeInputObservaciones = (id, event) => {
    const newInputFields = inputFields.map((i) => {
      if (id === i.id) {
        i.observacionesArticulo = event.target.value;
      }
      return i;
    });
    setInputFields(newInputFields);
    ActualizaTotales();
  };

  const handleChangeInput = (id, event) => {
    const newInputFields = inputFields.map((i) => {
      if (id === i.id) {
        i[event.target.name] = event.target.value;
        let totalParcial = i.cantidad * i.precio;
        i.total = totalParcial;
      }
      return i;
    });
    setInputFields(newInputFields);
    ActualizaTotales();
  };

  const handleChangeInputPrecio = (value, name, id) => {
    const newInputFields = inputFields.map((i) => {
      if (id === i.id) {
        i[name] = value;
        let totalParcial = i.cantidad * i.precio;
        i.total = totalParcial;
      }
      return i;
    });
    setInputFields(newInputFields);
    ActualizaTotales();
  };

  const handleChangeInputCajas = (id, event) => {
    const newInputFields = inputFields.map((i) => {
      if (id === i.id) {
        i.cajas = event.target.value;
        i.cantidad =
          parseFloat(event.target.value) * parseFloat(i.piezasPorCaja);
        let totalParcial = i.cantidad * i.precio;
        i.total = totalParcial;
      }
      return i;
    });
    setInputFields(newInputFields);
    ActualizaTotales();
  };

  const handleChangeInputCantidad = (id, event) => {
    const newInputFields = inputFields.map((i) => {
      if (id === i.id) {
        if (i.cantInv >= event.target.value) {
          i.cantidad = parseFloat(event.target.value);
          i.cajas = (
            parseFloat(event.target.value) / parseFloat(i.piezasPorCaja)
          ).toFixed(2);
          let totalParcial = i.cantidad * i.precio;
          i.total = totalParcial;
        } else {
          Swal.fire({
            icon: "error",
            title: "Oops...",
            text: "La cantidad excede tu inventario!",
            showConfirmButton: false,
          });
          i.cajas = 0;
          i.cantidad = 0;
        }
      }
      return i;
    });
    setInputFields(newInputFields);
    ActualizaTotales();
  };

  function BuscaArticulo(id, selectedArticulo) {
    console.log("hola", selectedArticulo)
    // if (
    //   inputFields.filter((e) => e.articulos == selectedArticulo.idArticulo).length > 0
    // ) {
    //   Swal.fire({
    //     icon: "error",
    //     title: "Oops...",
    //     text: "El modelo ya fue capturado!",
    //     showConfirmButton: false,
    //   });
    //   const newInputFields = inputFields.map((i) => {
    //     if (id === i.id) {
    //       i.articulosNombre = "";
    //       i.articulos = "";
    //     }
    //     return i;
    //   });
    //   setInputFields(newInputFields);
    // } else {
    // articulos.map((a) => {
    // if (a._id == selectedArticulo._id) {
    let idArticulo = selectedArticulo.idArticulo;
    let piezasPorCaja = selectedArticulo.piezasPorCaja;
    let articulosNombre = [selectedArticulo.MLM || selectedArticulo.SKU, selectedArticulo.nombre, selectedArticulo.variante]
      .filter(Boolean)
      .join(" ");
    // let idInv = selectedArticulo.idInv;
    let costoUnitario = selectedArticulo.costoUnitario;
    let precio;
    let precioOriginal;
          if (listaPrecios == 1) {
            precio = selectedArticulo.lista1;
            precioOriginal = selectedArticulo.lista1;
          } else if (listaPrecios == 2) {
            precio = selectedArticulo.lista2;
            precioOriginal = selectedArticulo.lista2;
          } else if (listaPrecios == 3) {
            precio = selectedArticulo.lista3;
            precioOriginal = selectedArticulo.lista3;
          } else if (listaPrecios == 4) {
            precio = selectedArticulo.lista4;
            precioOriginal = selectedArticulo.lista4;
          }
          let precioBruto;
          if (listaPrecios == 1) {
            // precioBruto = selectedArticulo.lista1;
            precioBruto = selectedArticulo.lista1Bruto;
          } else if (listaPrecios == 2) {
            // precioBruto = selectedArticulo.lista2;
            precioBruto = selectedArticulo.lista2Bruto;
          } else if (listaPrecios == 3) {
            // precioBruto = selectedArticulo.lista3;
            precioBruto = selectedArticulo.lista3Bruto;
          } else if (listaPrecios == 4) {
            // precioBruto = selectedArticulo.lista4;
            precioBruto = selectedArticulo.lista4Bruto;
          }
    const auth = { headers: { Authorization: `Bearer: ${localStorage.getItem("app_token")}` } };
    axios.get(`${URL_VARIANTES}/articulo/${idArticulo}`, auth)
      .then(res => {
        handleChangeInputArticulo(id, idArticulo, piezasPorCaja, precio, precioBruto, precioOriginal, articulosNombre, costoUnitario, res.data);
      })
      .catch(() => {
        handleChangeInputArticulo(id, idArticulo, piezasPorCaja, precio, precioBruto, precioOriginal, articulosNombre, costoUnitario, []);
      });
  }

  function BuscaLote(id, idInventario) {
    inventarios.map((a) => {
      if (a._id == idInventario) {
        let cantInv = parseFloat(a.cantidad);
        let idInv = a._id;
        let costoUnitario = a.costoUnitario
        handleChangeInputArticuloLote(id, cantInv, idInv, costoUnitario);
      }
    });
  }

  const handleChangeInputArticuloLote = (id, cantInv, idInv, costoUnitario) => {
    const newInputFields = inputFields.map((i) => {
      if (id === i.id) {
        i.cantInv = parseFloat(cantInv);
        i.idInv = idInv;
        i.costoUnitario = costoUnitario;
      }
      return i;
    });
    setInputFields(newInputFields);
    ActualizaTotales();
  };

  const handleChangeInputArticulo = (
    id,
    idArticulo,
    piezasPorCaja,
    precio,
    precioBruto,
    precioOriginal,
    articulosNombre,
    costoUnitario,
    variantesOptions = []
  ) => {
    const newInputFields = inputFields.map((i) => {
      if (id === i.id) {
        i.articulos = idArticulo;
        i.piezasPorCaja = piezasPorCaja;
        i.precio = precio;
        i.precioBruto = precioBruto;
        let totalParcial = i.cantidad * i.precio;
        i.total = totalParcial;
        i.articulosNombre = articulosNombre;
        i.precioOriginal = precioOriginal;
        i.costoUnitario = costoUnitario;
        i.idInv = "";
        i.variante = "";
        i.variantesOptions = variantesOptions;
      }
      return i;
    });
    setInputFields(newInputFields);
    ActualizaTotales();
  };

  function ActualizaTotales() {
    let totalKG = inputFields.map((c) => parseFloat(c.cantidad));
    let TK = totalKG.reduce((t, total, index) => t + total, 0);
    setTotalCantidad(TK);
    let totalCajas = inputFields.map((c) => parseFloat(c.cajas));
    let TCajas = totalCajas.reduce((t, total, index) => t + total, 0);
    setTotalCajas(TCajas);
    let importes = inputFields.map((c) => parseFloat(c.total));
    let TG = importes.reduce((t, total, index) => t + total, 0);
    setSubTotal(TG);

    if (selectedImpuesto != 0) {
      setIva((selectedImpuesto * TG) / 100);
    } else {
      setIva(0);
    }
    let temp1 = (TG * descuento) / 100;

    setDescuentoNumero(temp1);

    let totTemp =
      (selectedImpuesto * TG) / 100 +
      TG +
      parseFloat(comisionTDC) +
      parseFloat(comisionFlete) -
      parseFloat(temp1);

    setTotalGeneral(totTemp);

    setSaldo(totTemp - efectivo - tdc - transfer);
  }

  function calculaDescuento(e) {
    setDescuento(e);
    let temp1 = (subTotal * e) / 100;

    setDescuentoNumero(temp1);

    let temp = subTotal - temp1;

    let totTemp = temp + parseFloat(comisionTDC) + parseFloat(comisionFlete);

    setTotalGeneral(totTemp);
    setSaldo(totTemp - efectivo - tdc - transfer);
  }

  const options = articulosUnicos.map((option) => {
    const junta = (option.MLM || option.SKU) + " " + option.nombre + " " + option.variante;
    const firstLetter = option.SKU[0].toUpperCase();
    return {
      firstLetter: /[0-9]/.test(firstLetter) ? "0-9" : firstLetter,
      ...option,
      junta,
    };
  });

  function jalaCliente(cliente) {
    // setInputFields([
    //   {
    //     id: uuidv4(),
    //     articulos: "",
    //     piezasPorCaja: 0,
    //     cajas: 0,
    //     cantidad: 0,
    //     precio: 0,
    //     precioOriginal: 0,
    //     total: 0,
    //     articulosNombre: "",
    //     observacionesArticulo: "NA",
    //     idInv: "",
    //     costoUnitario:0
    //   },
    // ]);

    setSelectedCliente(cliente);

    axios
      .get(`${URL_CLIENTES}/${cliente}`, {
        headers: {
          Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
        },
      })
      .then((res) => {
        const allCliente = res.data;
        setCliente(allCliente);
        setSelectedColaborador(allCliente.vendedor[0]._id);
        setSelectedColaboradorName(
          allCliente.vendedor[0].nombre + " " + allCliente.vendedor[0].apellido
        );
        setDepartamentoCliente(allCliente.departamentosClientes[0]._id);
        setListaPrecios(allCliente.listaPrecios);
        // setCondPago(allCliente.forma_pago);
        // if(allCliente.forma_pago == "Credito"){
        //   setPago(false)
        // }else setPago(true)
      })
      .catch((err) => {
        console.log(err);
      });

    axios
      .get(`${URL_SUCURSALES}/clientes/${cliente}`, {
        headers: {
          Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
        },
      })
      .then((res) => {
        const allSucursales = res.data;
        setSucursales(allSucursales);
      })
      .catch((err) => {
        console.log(err);
      });
  }

  function jalaSucursal(value) {
    let split = value.split(",");
    let dir = split[0];
    let paq = split[1];

    setSelectedSucursal(value);
    setSucursal(dir);
  }

  function calculaImpuesto(e) {
    setSelectedImpuesto(e);
    if (e != 0) {
      setIva((e * subTotal) / 100);
    } else {
      setIva(0);
    }

    setTotalGeneral(
      (e * subTotal) / 100 +
        subTotal +
        parseFloat(comisionTDC) +
        parseFloat(comisionFlete)
    );

    setSaldo(
      (e * subTotal) / 100 +
        subTotal +
        parseFloat(comisionTDC) +
        parseFloat(comisionFlete) -
        efectivo -
        tdc -
        transfer
    );
  }

  function jalaComisionTDC(e) {
    setComisionTDC(e);
    if (selectedImpuesto != 0) {
      setIva((selectedImpuesto * subTotal) / 100);
    } else {
      setIva(0);
    }

    let temp =
      (selectedImpuesto * subTotal) / 100 +
      subTotal +
      parseFloat(e) +
      parseFloat(comisionFlete) -
      parseFloat((descuentoNumero * subTotal) / 100);

    setTotalGeneral(temp);

    setSaldo(temp - efectivo - tdc - transfer);
  }

  function jalaComisionFlete(e) {
    setComisionFlete(e);
    if (selectedImpuesto != 0) {
      setIva((selectedImpuesto * subTotal) / 100);
    } else {
      setIva(0);
    }

    let temp =
      (selectedImpuesto * subTotal) / 100 +
      subTotal +
      parseFloat(e) +
      parseFloat(comisionTDC) -
      parseFloat((descuentoNumero * subTotal) / 100);

    setTotalGeneral(temp);

    setSaldo(temp - efectivo - tdc - transfer);
  }

  // function autorizaCambio() {
  //   if (password == randomCambiaPrecio) {
  //     setCambiarPrecio(true);
  //     toggleCambiaPrecio();
  //     Swal.fire("Good job!", "Se autorizo con exito", "success");
  //   } else {
  //     Swal.fire({
  //       icon: "error",
  //       title: "Oops...",
  //       text: "La contraseña es incorrecta!",
  //     });
  //   }
  // }

  function autorizaCambio() {
    if (password == PASSWORD_CAMBIA_PRECIO) {
      setCambiarPrecio(true);
      toggleCambiaPrecio();
    } else {
      Swal.fire({
        icon: "error",
        title: "Oops...",
        text: "La contraseña es incorrecta!",
      });
    }
  }

  function solicitarAut() {
    setMailAutEnviado(true);

    axios
      .post(
        URL_SEND_MAIL,
        {
          subject: "Cambio de Precio",
          email: "danysalame18@gmail.com",
          text: `<table border="0" cellpadding="0" cellspacing="0" width="100%">
       <th><img width="${process.env.REACT_APP_TAMANO_LOGO_MAIL}" align="center" src="${process.env.REACT_APP_LINK_SISTEMA}logoInstitucion.png" /></th>
       <tr align="center" style="font-size:30px;font-family:Helvetica,Arial,sans-serif;color:#333333;padding-top:10px;font-weight:bold"><br>${process.env.REACT_APP_NOMBRE_INSTITUCION}</tr>
       <tbody>
       <tr style="font-size:20px;font-family:Helvetica,Arial,sans-serif;color:#333333;padding-top:10px;font-weight:bold"><br>Hola,</tr>
       <tr style="font-size:20px;font-family:Helvetica,Arial,sans-serif;color:#333333;padding-top:10px;font-weight:bold"><br>La tienda ${user.nombre} ${user.apellido} esta solicitando un cambio de precio, si lo autorizas proporciona la clave ${randomCambiaPrecio}</tr>
       </tbody>
       <tr style="font-size:16px;font-family:Helvetica,Arial,sans-serif;color:#333333;padding-top:10px"><br>Favor de no responder este correo, para cualquier duda favor de comunicarse al ${process.env.REACT_APP_TELEFONO_INSTITUCION}</tr>
       <tr align="right"><br>Powered by <a href="https://lynqro.com"> <img width="20%" align="center" src="${process.env.REACT_APP_LINK_SISTEMA}Logo-Lynqro-PDF.png" /> </a> </tr>
       </table>`,
        },
        {
          headers: {
            Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
          },
        }
      )
      .then(() => {
        Swal.fire("Good job!", "Enviado con exito", "success");
      })
      .catch((error) => {
        Swal.fire({
          icon: "error",
          title: "Oops...",
          text: "Something went wrong!",
          footer: `${error.response.data}`,
        });
        console.log(error);
      });
  }

  function jalaEfectivo(e) {
    setEfectivo(e);
    setSaldo(
      total_general - e - tdc - transfer
      // - cortesia
    );
  }

  function jalaTransfer(e) {
    setTransfer(e);
    if (e > 0) {
      setDestino("");
    } else {
      setDestino("NA");
    }
    setSaldo(total_general - efectivo - tdc - e);
  }

  function jalaTDC(e) {
    setTDC(e);
    if (e > 0) {
      setTerminal("");
    } else {
      setTerminal("NA");
    }
    setSaldo(total_general - efectivo - e - transfer);
  }

  function jalaArea(e) {
    setSelectedArea(e);
    areas.map((a) => {
      if (a._id == e) {
        setSelectedAreaName(a.name);
      }
    });
  }
  
  const sec = { borderLeft: "4px solid #3b82f6", paddingLeft: 12, marginBottom: 8, color: "#1e3a8a", fontWeight: 600, fontSize: "0.85rem", textTransform: "uppercase", letterSpacing: "0.05em" };
  const block = { background: "#f8fafc", borderRadius: 8, padding: "14px 16px", marginBottom: 16 };

  return (
    <>
      <Header />
      <br /><br />
      {user.pedidos_create ? (
        <div className="card container col-12">
          <h3 className="text-center mt-3 mb-3">Venta Directa</h3>

          {/* 📋 Encabezado */}
          <div style={block}>
            <div style={sec}>📋 Encabezado</div>
            <Row>
              <Col md={2}>
                <FormGroup>
                  <Label>Fecha</Label>
                  <Input type="date" value={fecha} required onChange={e => setFecha(e.target.value)} />
                </FormGroup>
              </Col>
              <Col md={3}>
                <FormGroup>
                  <Label>Cliente</Label>
                  <Input type="select" value={selectedCliente} required onChange={e => jalaCliente(e.target.value)}>
                    <option value="0">Selecciona</option>
                    {clientes.sort((a, b) => a.nombre_comercial > b.nombre_comercial ? 1 : -1).map(a => (
                      <option key={a._id} value={a._id}>{a.nombre_comercial}</option>
                    ))}
                  </Input>
                </FormGroup>
              </Col>
              <Col md={2}>
                <FormGroup>
                  <Label>Sucursal</Label>
                  <Input type="select" value={selectedSucursal} onChange={e => jalaSucursal(e.target.value)}>
                    <option value="">Selecciona una Sucursal</option>
                    {sucursales.sort((a, b) => a.alias > b.alias ? 1 : -1).map(a => {
                      if (a.is_active == "Si") return <option key={a._id} value={[a._id]}>{a.alias}</option>;
                    })}
                  </Input>
                </FormGroup>
              </Col>
              <Col md={2}>
                <FormGroup>
                  <Label>Vendedor</Label>
                  <Input type="select" value={selectedColaborador} disabled>
                    <option value="">Selecciona un Vendedor</option>
                    {colaboradores.sort((a, b) => a.nombre > b.nombre ? 1 : -1).map(a => (
                      <option key={a._id} value={a._id}>{a.nombre} {a.apellido}</option>
                    ))}
                  </Input>
                </FormGroup>
              </Col>
              <Col md={2}>
                <FormGroup>
                  <Label>Almacén a Surtir</Label>
                  <Input type="select" value={selectedArea} onChange={e => jalaArea(e.target.value)}>
                    <option value="">Selecciona un almacén</option>
                    {areas.sort((a, b) => a.name > b.name ? 1 : -1).map(a => (
                      <option key={a._id} value={a._id}>{a.name}</option>
                    ))}
                  </Input>
                </FormGroup>
              </Col>
            </Row>
            <Row>
              <Col md={4}>
                <FormGroup>
                  <Label>Observaciones</Label>
                  <Input type="textarea" value={observaciones} required onChange={e => setObservaciones(e.target.value)} />
                </FormGroup>
              </Col>
              {/* <Col md={2} className="d-flex align-items-end pb-3">
                <Button size="sm" color="info" onClick={toggleCambiaPrecio}>
                  <i className="fas fa-dollar-sign" style={{ marginRight: 5 }} />Cambio de Precio
                </Button>
              </Col> */}
            </Row>
          </div>

          {/* 💰 Totales */}
          <div style={block}>
            <div style={{ ...sec, display: "flex", justifyContent: "space-between", alignItems: "center" }}>
              <span>💰 Totales</span>
              <span style={{ background: "#dbeafe", color: "#1e3a8a", borderRadius: 20, padding: "2px 14px", fontSize: "0.85rem", fontWeight: 700 }}>
                {new Intl.NumberFormat("en-US").format(total_cantidad)} pzas · {new Intl.NumberFormat("en-US", { style: "currency", currency: "USD" }).format(total_general)}
              </span>
            </div>
            <Row>
              <Col md={1}>
                <FormGroup>
                  <Label>Impuestos %</Label>
                  <Input type="number" min="0" step="any" value={selectedImpuesto} onChange={e => calculaImpuesto(e.target.value)} />
                </FormGroup>
              </Col>
              <Col md={2}>
                <FormGroup>
                  <Label>Sub Total</Label>
                  <CurrencyInput intlConfig={{ locale: "en-US", currency: "USD" }} prefix="$" defaultValue={0} decimalsLimit={2} value={subTotal} disabled className="form-control" />
                </FormGroup>
              </Col>
              <Col md={2}>
                <FormGroup>
                  <Label>IVA</Label>
                  <CurrencyInput intlConfig={{ locale: "en-US", currency: "USD" }} prefix="$" defaultValue={0} decimalsLimit={2} value={iva} disabled className="form-control" />
                </FormGroup>
              </Col>
              <Col md={2}>
                <FormGroup>
                  <Label>Total</Label>
                  <CurrencyInput intlConfig={{ locale: "en-US", currency: "USD" }} prefix="$" defaultValue={0} decimalsLimit={2} value={total_general} disabled className="form-control" />
                </FormGroup>
              </Col>
              <Col md={1}>
                <FormGroup>
                  <Label>Piezas</Label>
                  <Input type="number" min="0" step="any" value={total_cantidad} disabled />
                </FormGroup>
              </Col>
            </Row>
          </div>

          {/* 💳 Pago */}
          <div style={block}>
            <div style={sec}>💳 Cobro</div>
            <Row>
              <Col md={2}>
                <FormGroup>
                  <Label>Efectivo</Label>
                  <CurrencyInput intlConfig={{ locale: "en-US", currency: "USD" }} prefix="$" defaultValue={0} decimalsLimit={2} value={efectivo} className="form-control" onValueChange={jalaEfectivo} />
                </FormGroup>
              </Col>
              <Col md={2}>
                <FormGroup>
                  <Label>TDC / Débito</Label>
                  <CurrencyInput intlConfig={{ locale: "en-US", currency: "USD" }} prefix="$" defaultValue={0} decimalsLimit={2} value={tdc} className="form-control" onValueChange={jalaTDC} />
                </FormGroup>
              </Col>
              <Col md={2}>
                <FormGroup>
                  <Label>Transferencia</Label>
                  <CurrencyInput intlConfig={{ locale: "en-US", currency: "USD" }} prefix="$" defaultValue={0} decimalsLimit={2} value={transfer} className="form-control" onValueChange={jalaTransfer} />
                </FormGroup>
              </Col>
              {transfer > 0 && (
                <Col md={2}>
                  <FormGroup>
                    <Label>Banco Destino</Label>
                    <Input type="select" value={destino} onChange={e => setDestino(e.target.value)}>
                      <option value="">Selecciona</option>
                      {bancos.sort((a, b) => a.banco > b.banco ? 1 : -1).map(a => (
                        <option key={a._id} value={a._id}>{a.banco}</option>
                      ))}
                    </Input>
                  </FormGroup>
                </Col>
              )}
              {tdc > 0 && (
                <Col md={2}>
                  <FormGroup>
                    <Label>Terminal</Label>
                    <Input type="text" value={terminal} onChange={e => setTerminal(e.target.value)} />
                  </FormGroup>
                </Col>
              )}
              <Col md={2}>
                <FormGroup>
                  <Label>Saldo</Label>
                  <CurrencyInput intlConfig={{ locale: "en-US", currency: "USD" }} prefix="$" defaultValue={0} decimalsLimit={2} value={saldo} disabled
                    className={`form-control${saldo > 0 ? " border-danger text-danger" : ""}`}
                    style={saldo > 0 ? { color: "#dc2626", borderColor: "#dc2626", fontWeight: 700 } : { color: "#16a34a", fontWeight: 600 }}
                  />
                </FormGroup>
              </Col>
            </Row>
          </div>

          {/* 📦 Artículos */}
          <div style={block}>
            <div style={{ ...sec, display: "flex", justifyContent: "space-between", alignItems: "center" }}>
              <span>📦 Artículos</span>
            </div>
            <div className="table-responsive">
              <table className="table table-sm table-bordered table-striped">
                <thead className="thead-light">
                  <tr>
                    <th style={{ minWidth: 220 }}>Artículo</th>
                    <th style={{ minWidth: 120 }}>Variante</th>
                    <th style={{ minWidth: 110 }}>Lote</th>
                    <th style={{ width: 80, textAlign: "center" }}>Inventario</th>
                    <th style={{ width: 85 }}>Cantidad</th>
                    <th style={{ width: 90 }}>Precio</th>
                    <th style={{ width: 90 }}>P. Bruto</th>
                    <th style={{ width: 95, textAlign: "right" }}>Total</th>
                    <th style={{ width: 70 }}></th>
                  </tr>
                </thead>
                <tbody>
                  {inputFields.map((inputField) => (
                    <tr key={inputField.id} style={inputField.cantInv < inputField.cantidad ? { background: "#fee2e2" } : undefined}>
                      <td>
                        <Autocomplete
                          size="small"
                          value={inputField.articulosNombre}
                          onChange={(event, selectedArticulo) => BuscaArticulo(inputField.id, selectedArticulo)}
                          options={options.sort((a, b) => -b.firstLetter.localeCompare(a.firstLetter))}
                          groupBy={(option) => option.firstLetter}
                          getOptionLabel={(option) => typeof option === "string" ? option : option.junta}
                          renderInput={(params) => <TextField {...params} label="Selecciona" variant="outlined" />}
                          renderOption={(option) => (
                            <React.Fragment>{option.MLM || option.SKU} {option.nombre} {option.variante}</React.Fragment>
                          )}
                        />
                      </td>
                      <td className="align-middle">
                        {inputField.variantesOptions && inputField.variantesOptions.length > 0 ? (
                          <Input type="select" bsSize="sm" value={inputField.variante}
                            onChange={e => setInputFields(inputFields.map(i =>
                              i.id === inputField.id
                                ? { ...i, variante: e.target.value, idInv: "", cantInv: 0 }
                                : i
                            ))}>
                            <option value="">Sin variante</option>
                            {inputField.variantesOptions.map(v => <option key={v._id} value={v._id}>{v.nombre}</option>)}
                          </Input>
                        ) : <span style={{ color: "#94a3b8", fontSize: "0.8rem" }}>—</span>}
                      </td>
                      <td>
                        <Input bsSize="sm" name="lote" type="select" value={inputField.idInv} required onChange={e => BuscaLote(inputField.id, e.target.value)}>
                          <option value="">Selecciona</option>
                          {inventarios.sort((a, b) => a.lote > b.lote ? 1 : -1).map(a => {
                            // Filtra por artículo; si hay variante seleccionada, también filtra por variante
                            const matchArt = a.idArticulo == inputField.articulos;
                            const matchVar = !inputField.variante || String(a.idVariante) === inputField.variante;
                            if (matchArt && matchVar) return <option key={a._id} value={a._id}>{a.lote}</option>;
                          })}
                        </Input>
                      </td>
                      <td className="align-middle text-center">
                        <span style={{ fontWeight: 600, color: inputField.cantInv > 0 ? "#16a34a" : "#dc2626" }}>
                          {new Intl.NumberFormat("en-US").format(inputField.cantInv)}
                        </span>
                      </td>
                      <td>
                        <Input bsSize="sm" name="cantidad" type="number" min="0" step="any" placeholder="Cant." value={inputField.cantidad} required
                          disabled={inputField.idInv === ""}
                          onChange={e => handleChangeInputCantidad(inputField.id, e)} />
                      </td>
                      <td>
                        <Input bsSize="sm" name="precio" type="number" min="0" step="any" value={inputField.precio} required
                          style={inputField.precioOriginal - 50 > inputField.precio && !cambiarPrecio ? { background: "#fee2e2" } : undefined}
                          onChange={e => handleChangeInput(inputField.id, e)} />
                      </td>
                      <td>
                        <Input bsSize="sm" name="precioBruto" type="number" min="0" step="any" value={inputField.precioBruto} onChange={e => handleChangeInput(inputField.id, e)} />
                      </td>
                      <td className="align-middle text-right">
                        <strong style={{ color: "#1e3a8a" }}>
                          {new Intl.NumberFormat("en-US", { style: "currency", currency: "USD" }).format(inputField.total)}
                        </strong>
                      </td>
                      <td className="align-middle text-center">
                        <Button size="sm" color="danger" disabled={inputFields.length === 1} onClick={() => handleRemoveFields(inputField.id)} tabIndex="-1">
                          <i className="fas fa-minus" />
                        </Button>{" "}
                        <Button size="sm" color="success" onClick={handleAddFields} tabIndex="-1">
                          <i className="fas fa-plus" />
                        </Button>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>

          {/* Botones */}
          <div className="mt-3 mb-4">
            {validaBoton ? (
              <Button color="success" onClick={savePedido}>
                <i className="fas fa-save" style={{ marginRight: 6 }} />Guardar Venta
              </Button>
            ) : (
              <Button color="success" disabled>
                <Spinner size="sm" style={{ marginRight: 6 }} />Guardando...
              </Button>
            )}{" "}
            <Button color="danger" href="/MenuVentas">
              <i className="fas fa-arrow-left" style={{ marginRight: 6 }} />Regresar
            </Button>
          </div>

          <Modal size="sm" isOpen={modalProgreso} toggle={toggleProgreso}>
            <ModalHeader toggle={toggleProgreso}><h4>Progreso</h4></ModalHeader>
            <ModalBody>
              <h4>Este proceso puede tardar varios segundos.<br />Por favor no cierre ni refresque su navegador.</h4>
              <br />
              <div className="progreso">
                <Spinner style={{ width: "50px", height: "50px", color: "#232B41" }} />
                <Spinner style={{ width: "50px", height: "50px", color: "#232B41" }} />
                <Spinner style={{ width: "50px", height: "50px", color: "#232B41" }} />
              </div>
            </ModalBody>
          </Modal>

          <Modal size="sm" isOpen={modalCambiaPrecio} toggle={toggleCambiaPrecio}>
            <ModalHeader toggle={toggleCambiaPrecio}><h4>Autorizar Cortesía</h4></ModalHeader>
            <ModalBody>
              <Input bsSize="sm" type="password" placeholder="Password" value={password} required onChange={e => setPassword(e.target.value)} />
              <br />
              <Button color="success" onClick={autorizaCambio}>Autorizar</Button>
            </ModalBody>
          </Modal>
        </div>
      ) : undefined}
    </>
  );
}

export default VentaDirectaCreate;
